import { baseUrl, filesUrl } from '@/shared/constants'
import axios, { AxiosResponse } from 'axios'
import { StoriesInfo } from '../types'

export const getStoriesInfo = async (token: string) => {
  const response: AxiosResponse<StoriesInfo> = await axios.get(`${baseUrl}/user/stories-info`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const postUploadStories = async (token: string, image: FormData) => {
  const response = await axios.post(`${filesUrl}_files/upload`, image, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  })

  return response.data
}
